import { AnimatePresence } from "framer-motion";
import React, { useEffect, useRef } from "react";
import BaseGrid from "@src/components/BaseGrid";

import {
	Frame,
	Container,
	CloseAtEnd,
	CloseButton,
	CloseButtonContainer,
} from "./styles";

interface Props {
	forVoice?: boolean;
	closeOnClick?: () => void;
	closeSelf?: () => void;
	updateChild?: (n: number) => void;
	isShown: boolean;
	activeChild?: number;
	showGrid?: boolean;
}

interface InnerProps {
	closeSelf?: () => void;
	forVoice?: boolean;
	id: number;
	showGrid?: boolean;
}

const animation = {
	frame: {
		hidden: {
			opacity: 0,
			transition: { duration: 0.5 },
		},
		shown: {
			opacity: 1,
			transition: { duration: 0.5 },
		},
	},
	container: {
		hidden: {
			opacity: 0,
			transition: { duration: 0.5 },
		},
		shown: {
			opacity: 1,
			transition: { duration: 0.5 },
		},
	},
};
const Inner: React.FC<InnerProps> = (props) => {
	const { children, closeSelf, forVoice, id, showGrid } = props;
	return (
		<Container
			animate="shown"
			initial="hidden"
			exit="hidden"
			variants={animation.container}
		>
			{showGrid && <BaseGrid />}
			{children}
			{forVoice && (
				<CloseAtEnd onClick={closeSelf}>
					<p>閉じる</p>
				</CloseAtEnd>
			)}
		</Container>
	);
};
const Modal: React.FC<Props> = (props) => {
	const {
		forVoice,
		closeOnClick,
		closeSelf,
		children,
		activeChild,
		isShown,
		showGrid,
	} = props;
	const frameRef = useRef<HTMLDivElement>(null);
	const resetFrame = () => {
		if (frameRef.current) frameRef.current.scrollTop = 0;
	};
	const stopScroll = () => {
		if (window) {
			window.document.body.style.width = `${window.document.body.clientWidth}px`;
			window.document.body.style.overflow = "hidden";
		}
	};
	const inheritScroll = () => {
		if (window) {
			window.document.body.style.overflow = "auto";
			window.document.body.style.width = "auto";
		}
	};
	useEffect(() => {
		if (isShown) {
			stopScroll();
		}
	}, [isShown]);
	return (
		<AnimatePresence onExitComplete={inheritScroll}>
			{isShown && (
				<Frame
					animate="shown"
					initial="hidden"
					exit="hidden"
					variants={animation.frame}
					onClick={() => {
						closeOnClick && closeSelf && closeSelf();
					}}
					ref={frameRef}
				>
					<CloseButtonContainer>
						<CloseButton onClick={closeSelf} forVoice={forVoice} />
					</CloseButtonContainer>
					<AnimatePresence exitBeforeEnter onExitComplete={resetFrame}>
						{
							(children instanceof Array
								? children.map((child, index) => (
										<Inner
											key={index}
											forVoice={forVoice}
											closeSelf={closeSelf}
											id={index}
											showGrid={showGrid}
										>
											{child}
										</Inner>
								  ))
								: [
										<Inner forVoice={forVoice} closeSelf={closeSelf} id={0}>
											{children}
										</Inner>,
								  ])[activeChild != undefined ? activeChild : 0]
						}
					</AnimatePresence>
				</Frame>
			)}
		</AnimatePresence>
	);
};

export default Modal;
